export default {
  computed: {
    onChangeWindowSize() {
      return this.getDeviceInfo();
    },
  },
  methods: {
    getWindowWidth() {
      return this.$store.state.windowWidth;
    },
    getWindowHeight() {
      return this.$store.state.windowHeight;
    },
    getUserAgent() {
      return this.$store.state.deviceInfo.userAgent;
    },
    getDeviceInfo() {
      return {
        "width": this.$store.state.windowWidth,
        "height": this.$store.state.windowHeight,
        "deviceType": this.$store.state.deviceInfo.deviceType,
        "deviceOrientation": this.$store.state.deviceInfo.orientation,
        "browser": this.$store.state.deviceInfo.browser,
      }
    },
    // iPhone も含めた iOS 端末か否かを判定
    isIOS() {
      let ua = this.$store.state.deviceInfo.userAgent.toLowerCase();
      return (ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1 || ua.indexOf('macintosh') > -1 && 'ontouchend' in document)
    },

    // iOS12 と iPadOS どちらでも iPad か否かを判定
    isIPad() {
      let ua = this.$store.state.deviceInfo.userAgent.toLowerCase();
      return (ua.indexOf('ipad') > -1 || ua.indexOf('macintosh') > -1 && 'ontouchend' in document)
    },
  }
};
